export const generateKML = (type, fileName, features) => {
  const kmlHeader = `<?xml version="1.0" encoding="UTF-8"?>
<kml xmlns="http://www.opengis.net/kml/2.2">
  <Document>
`;

  const kmlFooter = `  </Document>
</kml>`;

  let kmlBody = "";

  features.forEach((feature) => {
    const { geometry, properties = {}, id } = feature;

    if (geometry.type === "Point") {
      const [lon, lat] = geometry.coordinates;
      kmlBody += `
    <Placemark>
      <name>Point - ${properties.id || id || "Unknown"}</name>
      <Point>
        <coordinates>${lon},${lat},0</coordinates>
      </Point>
    </Placemark>
`;
    } else if (geometry.type === "LineString") {
      const coordinates = geometry.coordinates
        .map(([lon, lat]) => `${lon},${lat},0`)
        .join(" ");
      kmlBody += `
    <Placemark>
      <name>Line - ${properties.id || id || "Unknown"}</name>
      <LineString>
        <coordinates>${coordinates}</coordinates>
      </LineString>
    </Placemark>
`;
    } else if (geometry.type === "Polygon") {
      const coordinates = geometry.coordinates[0]
        .map(([lon, lat]) => `${lon},${lat},0`)
        .join(" ");
      kmlBody += `
    <Placemark>
      <name>Polygon - ${properties.id || id || "Unknown"}</name>
      <Polygon>
        <outerBoundaryIs>
          <LinearRing>
            <coordinates>${coordinates}</coordinates>
          </LinearRing>
        </outerBoundaryIs>
      </Polygon>
    </Placemark>
`;
    }
  });

  const kmlContent = kmlHeader + kmlBody + kmlFooter;

  const blob = new Blob([kmlContent], {
    type: "application/vnd.google-earth.kml+xml",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.kml`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
